























import BaseComponent from '@/components/base-component.vue';
import { parseRoutes } from '@/helpers/parseRoutes';
import { IMenuGroup } from '@/interfaces/menu';
import router, { routes } from '@/routes';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class SideMenu extends BaseComponent {
  @Prop({
    default: true,
  })
  public drawer: boolean;
  public groupedRoutes: IMenuGroup[];

  public drawerIsOpen: boolean = null;

  @Watch('drawer', {immediate: true})
  public onChangeDrawer(): void {
    this.drawerIsOpen = this.drawer;
  }

  @Watch('drawerIsOpen')
  public onChangeDrawerIsOpen(): void {
    this.$emit('toggle', this.drawerIsOpen);
  }

  public beforeMount(): void {
    this.loadMenu();
  }

  public redirect(path) {
    router.push(path);
  }

  private loadMenu(): void {
    this.groupedRoutes = parseRoutes(routes);
  }
}
